import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Auth pages
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword";

// Role-based routes
import HrRoutes from "./routes/HrRoutes";
import EmployeeRoutes from "./routes/EmployeeRoutes";
import ManagerRoutes from "./routes/ManagerRoutes";

import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Auth */}
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot" element={<ForgotPassword />} />

        {/* HR */}
        <Route path="/hr/*" element={<HrRoutes />} />

        {/* Employee */}
        <Route path="/employee/*" element={<EmployeeRoutes />} />

        {/* Manager */}
        <Route path="/manager/*" element={<ManagerRoutes />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
